import { render, staticRenderFns } from "./Leftmenu_baby.vue?vue&type=template&id=55c48230&scoped=true"
import script from "./Leftmenu_baby.vue?vue&type=script&lang=js"
export * from "./Leftmenu_baby.vue?vue&type=script&lang=js"
import style0 from "./Leftmenu_baby.vue?vue&type=style&index=0&id=55c48230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c48230",
  null
  
)

export default component.exports